<script setup lang="ts">
import MailIcon from '@/assets/svg/mail-01-16.svg?component';
import IntakeAddressField from '@/components/Shared/ResumeUpload/IntakeAddressField.vue';
import { EMAIL_FORWARDING_LEARN_MORE_URL, useIntakeAddress } from '@/composables/useIntakeAddress';

const props = defineProps<{
  jobId: number;
}>();

const { address, displayAddress, isLoading, hasError, justCopied, fetchAddress, handleCopy } =
  useIntakeAddress(() => props.jobId);
</script>

<template>
  <div
    class="flex flex-col items-start gap-2.5 rounded-md border border-highlight-100 bg-highlight-0 p-4"
  >
    <div class="flex items-start gap-2 font-sans text-sm font-medium text-shade-900">
      <MailIcon class="mt-0.5 h-4 w-4 shrink-0" />
      Uploading often? Automatically forward resumes to this job via email.
    </div>

    <IntakeAddressField
      :address="address"
      :display-address="displayAddress"
      :is-loading="isLoading"
      :has-error="hasError"
      :just-copied="justCopied"
      @copy="handleCopy"
      @retry="fetchAddress"
    />

    <a
      v-if="address && !hasError"
      :href="EMAIL_FORWARDING_LEARN_MORE_URL"
      target="_blank"
      rel="noopener noreferrer"
      class="self-start font-sans text-sm font-semibold text-highlight-600 hover:underline"
    >
      Learn more about email forwarding →
    </a>
  </div>
</template>
